// extracted by mini-css-extract-plugin
module.exports = {"sidebarTitle":"Sidebar_sidebarTitle__TF8aU","scrollBarMenu":"Sidebar_scrollBarMenu__R5quS"};